import { Component, Input } from '@angular/core';
import { Filter } from '../../models/filter-models';
import { Rarity } from "../../models/enums";
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { FilterService } from '../../services/filter.service';
import { SelectRarityComponent } from '../../common/select/select-rarity/select-rarity.component';
import { BaseComponent } from '../../common/base.component';
import { ActiveRules } from '../../services/filter-generator.service';
import { poe1 } from '../../../game';
import { ItemData, BaseType } from '../../models/item-data-models';
import { ItemDataService } from '../../services/item-data.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-remaining-equipment-filters',
  imports: [FormsModule, FilterTitleComponent, SelectRarityComponent],
  templateUrl: './remaining-equipment-filters.component.html',
  styleUrl: './remaining-equipment-filters.component.scss'
})
export class RemainingGearFiltersComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  itemData: ItemData[];

  ringBaseTypes: BaseType[];
  amuletBaseTypes: BaseType[];
  talismanBaseTypes: BaseType[];
  beltBaseTypes: BaseType[];
  jewelBaseTypes: BaseType[];

  Rarity = Rarity;

  constructor(private filterService: FilterService, private itemDataService: ItemDataService, private navigationService: NavigationService) {
    super();

    this.itemData = this.itemDataService.getItemData();

    this.ringBaseTypes = this.itemData.find(i => i.itemType === 'Rings')!.baseTypes;
    this.amuletBaseTypes = this.itemData.find(i => i.itemType === 'Amulets')!.baseTypes;
    this.talismanBaseTypes = this.poe2 ? [] : this.itemData.find(i => i.itemType === 'Talismans')!.baseTypes;
    this.beltBaseTypes = this.itemData.find(i => i.itemType === 'Belts')!.baseTypes;
    this.jewelBaseTypes = [...this.itemData.find(i => i.itemType === 'Jewels')!.baseTypes];
    if (poe1) this.jewelBaseTypes.push(...this.itemData.find(i => i.itemType === 'Abyss Jewels')!.baseTypes);
  }

  toggleHideAllOtherGear(){ this.filter.hideAllOtherGear = !this.filter.hideAllOtherGear; this.updateFilter(); }

  toggleHideAmulets = () => { this.filter.hideAmulets = !this.filter.hideAmulets; this.updateFilter(); }
  toggleHideTalismans = () => { this.filter.hideTalismans = !this.filter.hideTalismans; this.updateFilter(); }
  toggleHideRings = () => { this.filter.hideRings = !this.filter.hideRings; this.updateFilter(); }
  toggleHideBelts = () => { this.filter.hideBelts = !this.filter.hideBelts; this.updateFilter(); }
  toggleHideJewels = () => { this.filter.hideJewels = !this.filter.hideJewels; this.updateFilter(); }

  toggleHideLifeFlasks = () => {
    this.filter.hideLifeFlasks = !this.filter.hideLifeFlasks; this.updateFilter();
    if (!this.filter.hideLifeFlasks && !this.filter.hideManaFlasks) {
      this.filter.showQualityFlasks = false;
    } else {
      this.filter.showQualityFlasks = true;
    }
    this.updateFilter();
  }

  toggleHideManaFlasks = () => {
    this.filter.hideManaFlasks = !this.filter.hideManaFlasks; this.updateFilter();
    if (!this.filter.hideLifeFlasks && !this.filter.hideManaFlasks) {
      this.filter.showQualityFlasks = false;
    } else {
      this.filter.showQualityFlasks = true;
    }
    this.updateFilter();
  }

  toggleHideHybridFlasks = () => {
    this.filter.hideHybridFlasks = !this.filter.hideHybridFlasks; this.updateFilter();
    if (!this.filter.hideLifeFlasks && !this.filter.hideHybridFlasks) {
      this.filter.showQualityFlasks = false;
    } else {
      this.filter.showQualityFlasks = true;
    }
    this.updateFilter();
  }

  toggleHideUtilityFlasks = () => {
    this.filter.hideUtilityFlasks = !this.filter.hideUtilityFlasks; this.updateFilter();
    if (!this.filter.hideLifeFlasks && !this.filter.hideUtilityFlasks) {
      this.filter.showQualityFlasks = false;
    } else {
      this.filter.showQualityFlasks = true;
    }
    this.updateFilter();
  }

  toggleHideTinctures = () => { this.filter.hideTinctures = !this.filter.hideTinctures; this.updateFilter(); }
  toggleHideCharms = () => { this.filter.hideCharms = !this.filter.hideCharms; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }

  navigateToLevelingGear = () => {
    this.navigationService.navigateToFilterTitle('gear-leveling-weapons');
  }

  navigateToLevelingFlasks = () => {
    this.navigationService.navigateToFilterTitle('flasks-leveling-life-mana');
  }
}
